import { render, staticRenderFns } from "./SmartObjectSimplePlaceholderNodeView.vue?vue&type=template&id=7bb0c0d8"
import script from "./SmartObjectSimplePlaceholderNodeView.vue?vue&type=script&lang=js"
export * from "./SmartObjectSimplePlaceholderNodeView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports